import { GET_APP_EXCLUSIONS, POST_APP_EXCLUSION, DELETE_APP_EXCLUSION } from '../../types'

const initialState = {
  appExclusions: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_APP_EXCLUSIONS: return {
      ...state,
      appExclusions: action.payload
    }
    case POST_APP_EXCLUSION: return {
      ...state
    }
    case DELETE_APP_EXCLUSION: return {
      ...state
    }
    default: return { ...state }
  }
}
